import { useEffect, useState } from "react";

const AddHomeModal = () => {
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
  const [showPopup, setShowPopup] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    setIsIOS(/iphone|ipad|ipod/.test(userAgent));
  
    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      (window.navigator as any).standalone;
  
    if (isStandalone) {
      setShowPopup(false);
      return; 
    }
  
    const handleBeforeInstallPrompt = (event: any) => {
      event.preventDefault();
      setDeferredPrompt(event);
      if (!localStorage.getItem("pwaPopupDismissed")) {
        setShowPopup(true);
      }
    };
  
    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
  
    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === "accepted") {
        console.log("✅ PWA 설치 완료");
      } else {
        console.log("❌ PWA 설치 취소");
      }
      setDeferredPrompt(null);
      setShowPopup(false);
    }
  };

  const handleClosePopup = () => {
    setShowPopup(false);
    localStorage.setItem("pwaPopupDismissed", "true"); // 다시 나타나지 않도록 저장
  };

  if (!showPopup) return null; // 팝업 숨김

  return (
    <div
      style={{
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: "#007bff",
        color: "#fff",
        padding: "10px",
        textAlign: "center",
        zIndex: 1000,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      {isIOS ? (
        <span>📢 Safari에서 "공유 버튼(⬆️)" → "홈 화면에 추가"를 선택하세요!</span>
      ) : (
        <span>📢 앱을 설치하여 더욱 편리하게 사용하세요!</span>
      )}

      <div>
        {!isIOS && (
          <button
            onClick={handleInstallClick}
            style={{
              backgroundColor: "#fff",
              color: "#007bff",
              border: "none",
              padding: "5px 10px",
              marginLeft: "10px",
              cursor: "pointer",
              borderRadius: "5px",
            }}
          >
            설치하기
          </button>
        )}
        <button
          onClick={handleClosePopup}
          style={{
            backgroundColor: "transparent",
            color: "#fff",
            border: "none",
            padding: "5px 10px",
            marginLeft: "10px",
            cursor: "pointer",
          }}
        >
          닫기
        </button>
      </div>
    </div>
  );
};

export default AddHomeModal;
